'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _ListNoPagination = require('shared/components/ListNoPagination');

var _JobListing = require('./JobListing');

var _JobListing2 = _interopRequireDefault(_JobListing);

var _selectors = require('./selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iterator = function iterator(_ref) {
  var id = _ref.id,
      title = _ref.title,
      image = _ref.image,
      content = _ref.content,
      categories = _ref.categories,
      subsectors = _ref.subsectors,
      fullSlug = _ref.fullSlug,
      skills = _ref.skills,
      matches = _ref.matches,
      userSkills = _ref.userSkills;
  return _react2.default.createElement(_JobListing2.default, {
    key: id,
    title: title,
    content: content,
    image: image.url,
    fullSlug: fullSlug,
    subsectors: subsectors,
    categories: categories,
    skills: skills,
    matches: matches,
    userSkills: userSkills
  });
}; /*
      {
      "type": "job_list"
      }
   
      Specifically for the Job List page, displays a list of jobs.
      */


function JobList(_ref2) {
  var moduleClass = _ref2.moduleClass,
      jobs = _ref2.jobs;

  // this controls the number of jobs
  // that are on a page of the job
  // list at any given time.
  var jobsPerPage = 5;

  return _react2.default.createElement(
    'div',
    {
      className: 'type-job_list ' + moduleClass
    },
    _react2.default.createElement(_ListNoPagination.ListNoPagination, {
      id: 'job-list',
      label: 'See more career matches',
      perPage: jobsPerPage,
      data: jobs,
      iteratorFn: iterator
    })
  );
}

exports.default = (0, _reactRedux.connect)(_selectors.mapStateToProps)(JobList);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/JobList/JobList.jsx
// module id = 1184
// module chunks = 0